import { useExperiment, useExperimentVariant } from "@hopper-b2b/experiments";
import { ExperimentVariant } from "@hopper-b2b/types";
import { PATH_HOME, PATH_TRIPS } from "../urlPaths";

const LEGACY_TRIPS_URL = `${PATH_HOME}${PATH_TRIPS}`;
const HTS_ASSIST_LOBBY_URL = `${LEGACY_TRIPS_URL}?platform=hts&lobby=true`;
const HTS_COMMERCE_TRIPS_URL = `${LEGACY_TRIPS_URL}?platform=hts`;

export type HtsPlatformTripsUrl = {
  /** The href a trips navigation link should point to. */
  tripsHref: string;
  /**
   * True when the destination is the HTS Assist lobby. Callers use this to pick
   * the "Trips & Support" vs "My Trips" label — the URL hook does not own labels.
   */
  isHtsAssistLobby: boolean;
};

/**
 * Resolves the trips navigation URL from the two HTS trips feature flags.
 *
 * Precedence (Assist lobby wins):
 *  1. `HtsAssistLobby` — the default experience for everyone; it acts as a
 *     kill-switch, so only an explicit `control` assignment opts out. Routes to
 *     the HTS Assist lobby (`?platform=hts&lobby=true`).
 *  2. `TripsCommercePlatformHopperWebRollout` — secondary, default-off. Routes to
 *     the HTS commerce-platform trips (`?platform=hts`).
 *  3. Neither — the legacy `/trips` route, preserved so existing booking links
 *     back to the old experience keep working.
 */
export const useHtsPlatformTripsUrl = (): HtsPlatformTripsUrl => {
  const htsAssistLobbyEnabled =
    useExperimentVariant("HtsAssistLobby") !== ExperimentVariant.Control;
  const tripsCommercePlatformEnabled = useExperiment(
    "TripsCommercePlatformHopperWebRollout"
  );

  if (htsAssistLobbyEnabled) {
    return { tripsHref: HTS_ASSIST_LOBBY_URL, isHtsAssistLobby: true };
  }

  if (tripsCommercePlatformEnabled) {
    return { tripsHref: HTS_COMMERCE_TRIPS_URL, isHtsAssistLobby: false };
  }

  return { tripsHref: LEGACY_TRIPS_URL, isHtsAssistLobby: false };
};
